/*
 * @Copyright: 网易集成平台
 * @Author: xiaowenwen
 * @Date: 2021-12-20 16:44:50
 * @LastEditTime: 2021-12-20 16:44:51
 * @Description:邮箱用户操作日志
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/sync/userbehavior/${action[0]}`;

export default class LOG {
  static LIST(params) {
    return http.get(url`list`, { params });
  }
  static DELETE(data) {
    return http.post(url`delete`, data, formConfig);
  }
}
